module.exports = __webpack_public_path__ + "static/media/DashboardImage.43160565.webp";